import { googleMapsEnabled, isConsumer } from 'src/config'
import Model from 'src/models/Model'

export default async ({ app }) => {
  if (!isConsumer) return
  if (!googleMapsEnabled) return

  let distanceMatrixService = null
  const unitSystem = _.toUpper(Model?.configuration?.currentCircuit?.iso31661) === 'US' ? window.google.maps.UnitSystem.IMPERIAL : window.google.maps.UnitSystem.METRIC

  function createDistanceMatrixService () {
    distanceMatrixService = new window.google.maps.DistanceMatrixService()
  }

  async function getClosestLocations (origin, siteLocations) {
    if (!googleMapsEnabled) return null

    // google maps service can only get distances for destinations and origins in groups of 25
    const closestLocations = []
    const maxDistances = 24
    const destinationGroups = _.chunk(siteLocations, maxDistances)

    const locationDistances = _.map(destinationGroups, async (destinationGroup) => {
      const distances = await getDistances(origin, destinationGroup)
      closestLocations.push(distances)
    })
    await Promise.all(locationDistances)

    return _(closestLocations).flatten().sortBy(closestLocations, location => location.currentDistanceValue).value()
  }

  function getDistances (origin, destinationGroup) {
    const closestLocations = []

    const destinations = destinationGroup.map(destination => `${destination.address1} ${destination.city} ${destination.state} ${destination.zip}`)
    const travelMode = 'DRIVING'
    const successStatus = 'OK'

    if (!distanceMatrixService) {
      createDistanceMatrixService()
    }

    return distanceMatrixService.getDistanceMatrix(
      {
        origins: [origin],
        destinations,
        travelMode,
        unitSystem
      }).then(response => {
      if (response) {
        _.each(destinationGroup, (siteLocation, i) => {
          if (response.rows[0].elements[i].status === successStatus) {
            siteLocation.currentDistanceText = response.rows[0].elements[i].distance.text
            siteLocation.currentDistanceValue = response.rows[0].elements[i].distance.value
            closestLocations.push(siteLocation)
          }
        })
      }
      return closestLocations
    })
  }

  app.config.globalProperties.$getClosestLocations = getClosestLocations
}
